import React, { useEffect, useState } from "react";
import "./section7.css";
import { Grid } from "@material-ui/core";
import ControlledAccordions from "./faq-main";
import GroupedButtons from "./GroupedButtons";
import graph from "../img/graph.png";
import n1 from "../img/1.png";
import n2 from "../img/2.png";
import n3 from "../img/3.png";
import n4 from "../img/4.png";
import n5 from "../img/5.png";
import { ethers } from "ethers";
import ICO from "../abi/PhaseOne.json";
import Radio from '@mui/material/Radio';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* bhai ye error messege show krne ke liye h */



const ICOAddress = "0xB8e497E28460F6F0683B47b7ae5dF0cf87a12147";
const NFTAddress = "0xC9D7124EBD6545a2fe9e3e858B2369a8865a998e";
const BOITAddress = "0x178c01196CAf879805b61458F2B322D6c9B7ee40";
const USDTAddress = "0xBD693EF569f2961917981Ad893dF0257D655747B";

function Section7() {
  const [selectedValue, setSelectedValue] = React.useState('a');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const [slot, setSlot] = useState([]);
  useEffect(() => {
    getSlot();
  });
  const getSlot = async () => {
    let tempSlot = [];
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      const ICOContract = new ethers.Contract(ICOAddress, ICO, signer);
      tempSlot.push(await ICOContract.slotId(1));
      tempSlot.push(await ICOContract.slotId(2));
      tempSlot.push(await ICOContract.slotId(3));
      tempSlot.push(await ICOContract.slotId(4));
      tempSlot.push(await ICOContract.slotId(5));
      setSlot(tempSlot);
    } catch (error) {
      console.log(error);
    }
    
  };
  const notify = ()=>{                                 /* Maine yaha notify wala describe kiya h isi funtion ko jb hit krega toh pop error ayega  */
 
  
    toast.error("l1",
           {position: toast.POSITION.BOTTOM_LEFT})   /* ye ankita wala lagana h baki remove kr diyo samjha anil bhosidike  */
        toast.info('Error Ankita',
           {position: toast.POSITION.BOTTOM_RIGHT})
        toast.warning('Error Anil',
           {position: toast.POSITION.BOTTOM_CENTER})
        toast.success('Error Aakarshit',
           {position: toast.POSITION.TOP_LEFT})
        toast.warning('Error Rishabh',
           {position: toast.POSITION.TOP_RIGHT})
        toast.info('Error Vishal',
           {position: toast.POSITION.TOP_CENTER})
}
  return (
    <div>
      <div id="section7" className="section7">
        <div className="section7Grid">
          <Grid container spacing={0}>
            <Grid item xs={6} sm={6}>
              <h1 className="token-utilisation">
               $BOIT ICO <br />
                <span className="sub-head-ico"></span>
              </h1>
              <p className="para-tokenUtilisation">
              The first round, possibly the lowest price for $BOIT takes place for family, friends and early backers of the BOIT club project. The proceeds of this round will be used for product development, providing liquidity, Conducting token audits, various listings and finally getting the project ready for stage 4 - The first time public will have access to free trade of $BOIT
              </p>
            </Grid>
            <Grid item xs={6} sm={6}>
              <div className="table">
                <ControlledAccordions />
              </div>
            </Grid>
          </Grid>
        </div>
        <button onClick={notify}>Click Me!</button>
        <ToastContainer />  {/* Ye button se function call kr rha tha isko hata dena or function call ko useState mein le lena agar itna nhi kr paye chullu bhar pani mein dub marna nikal bhosidike or haan comment sare delete kr dena wrna ma chod denge bhosidike  */}
        <div className="tableSection">
          <Grid container spacing={0}>
            <Grid item xs={6} sm={6}>
              <div className="graph">
                <img className="graphImg" src={graph} />
              </div>
            </Grid>
            <Grid item xs={6} sm={6}>
              <div className="dataSection">
                <h1 className="DataHead">Things you need do</h1>

                <ol start='01' className="data-02">
                  <li>Install metamask web browser extension <a href='https://www.geeksforgeeks.org/how-to-install-and-use-metamask-on-google-chrome/' target='_blank'>Click Here</a></li>
                  <li>Move ETH into Metamask wallet using any centralised exchange. Please make sure you transfer funds over ERC20 network. <a href='https://decentralizedcreator.com/withdraw-ethereum-from-binance/?amp=1' target='_blank'>Click Here</a></li>
                  <li>
                  Convert ETH to USDC within Metamask <a href='https://metamask.io/swaps/' target='_blank'>Click Here</a>
                  </li>
                  <li>Mint token by connecting wallet</li>
                  <li>
                  Add token Contract Address: <a href='https://etherscan.io/token/0xc6ee07B80D56bc4D586fE03F32D57c83e007b60A' target='_blank'>0xc6ee07B80D56bc4D586fE03F32D57c83e007b60A</a> to metamask to view your tokens <a href='https://metamask.zendesk.com/hc/en-us/articles/360015489031-How-to-add-unlisted-tokens-custom-tokens-in-MetaMask#h_01FWH492CHY60HWPC28RW0872H' target='_blank'>Click Here</a>
                  </li>
                  
                
                </ol>
              </div>
            </Grid>
          </Grid>

          <div className="dataMain"></div>
        </div>
        <div className="TableGridContainer">
          <Grid container spacing={0} className="TableGrid">
            <Grid
              item
              xs={2}
              sm={2}
              style={{ borderRight: "2px solid rgba(128, 115, 165, 0.1)" }}
            >
              <div className="nftBox">
                <div className="BOX"></div>
              </div> 
              <h1 className="tableSideHead" style={{marginTop: '1.35rem'}}> Class</h1>
              <h1 className="tableSideHead"> Tokens</h1>
              <h1 className="tableSideHead"> US$ Value</h1>
              <h1 className="tableSideHead">Investment (USDC)</h1>
              <h1 className="tableSideHead"> Slots</h1>
              <h1 className="tableSideHead"> Quantity</h1>
              <h1 className="tableSideHead"> Payment Mode</h1>
              
              <Grid container spacing={0}>
                <Grid item xs={6} sm={6} style={{textAlign: '-webkit-center'}}>
                  <Radio
                    checked={selectedValue === 'a'}
                    onChange={handleChange}
                    value="a"
                    name="radio-buttons"
                    inputProps={{ 'aria-label': 'A' }}
                  />
                   <h1 className="tableSideHeadPay"> ETH</h1>
                  </Grid>
                  <Grid item xs={6} sm={6} style={{textAlign: '-webkit-center'}}>
                  <Radio
                    checked={selectedValue === 'b'}
                    onChange={handleChange}
                    value="b"
                    name="radio-buttons"
                    inputProps={{ 'aria-label': 'B' }}
                  />
                   <h1 className="tableSideHeadPay"> USDC</h1>
                </Grid>
              </Grid>             
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              style={{ borderRight: "2px solid rgba(128, 115, 165, 0.1)" }}
            >
              <div className="nftBox">
                <img className="nftImg" src={n1} />
              </div>
              <h1 className="tableSideHead" style={{textAlign: '-webkit-center'}}> Stage 1</h1>
              <h1 className="tableContent"> 50,000</h1>
              <h1 className="tableContent"> 0.0100</h1>
              <h1 className="tableContent"> 500</h1>
              <h1 className="tableContent">
                {" "}
                {slot[0] === undefined ? 40 : `${slot[0].toString()}/40`}
              </h1>
              <div className="quantityButton">
                <GroupedButtons />
              </div>
              <div className="btn-mint">
                <button className="mintBtn" onClick={() => getSlot()}>
                  {" "}
                  MINT{" "}
                </button>
              </div>
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              style={{ borderRight: "2px solid rgba(128, 115, 165, 0.1)" }}
            >
               <div className="nftBox">
                <img className="nftImg" src={n2} />
              </div>
              <h1 className="tableSideHead" style={{textAlign: '-webkit-center'}}> Stage 2</h1>
              <h1 className="tableContent"> 120,000</h1>
              <h1 className="tableContent"> 0.0083</h1>
              <h1 className="tableContent"> 1000</h1>
              <h1 className="tableContent">
                {" "}
                {slot[1] === undefined ? 25 : `${slot[1].toString()}/25`}
              </h1>
              <div className="quantityButton">
                <GroupedButtons />
              </div>
              <div className="btn-mint">
                <button className="mintBtn"> MINT </button>
              </div>
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              style={{ borderRight: "2px solid rgba(128, 115, 165, 0.1)" }}
            >
               <div className="nftBox">
                <img className="nftImg" src={n3} />
              </div>
              <h1 className="tableSideHead" style={{textAlign: '-webkit-center'}}> Stage 3</h1>
              <h1 className="tableContent"> 200,000</h1>
              <h1 className="tableContent">0.0075</h1>
              <h1 className="tableContent">2000 </h1>
              <h1 className="tableContent">
                {slot[2] === undefined ? 15 : `${slot[2].toString()}/15`}{" "}
              </h1>
              <div className="quantityButton">
                <GroupedButtons />
              </div>
              <div className="btn-mint">
                <button className="mintBtn"> MINT </button>
              </div>
            </Grid>
            <Grid
              item
              xs={2}
              sm={2}
              style={{ borderRight: "2px solid rgba(128, 115, 165, 0.1)" }}
            >
               <div className="nftBox">
                <img className="nftImg" src={n4} />
              </div>
              <h1 className="tableSideHead" style={{textAlign: '-webkit-center'}}> Stage 4</h1>
              <h1 className="tableContent"> 300,000</h1>
              <h1 className="tableContent">0.0067</h1>
              <h1 className="tableContent">5000 </h1>
              <h1 className="tableContent">
                {slot[3] === undefined ? 10 : `${slot[3].toString()}/10`}{" "}
              </h1>
              <div className="quantityButton">
                <GroupedButtons />
              </div>
              <div className="btn-mint">
                <button className="mintBtn"> MINT </button>
              </div>
            </Grid>
            <Grid item xs={2} sm={2} >
              <div className="nftBox">
                <img className="nftImg" src={n5} />
              </div>
              <h1 className="tableSideHead" style={{textAlign: '-webkit-center'}}> Stage 5</h1>
              <h1 className="tableContent"> 900,000 </h1>
              <h1 className="tableContent">0.0056 </h1>
              <h1 className="tableContent">10000 </h1>
              <h1 className="tableContent">
                {slot[4] === undefined ? 10 : `${slot[4].toString()}/10`}{" "}
              </h1>
              <div className="quantityButton">
                <GroupedButtons />
              </div>
              <div className="btn-mint">
                <button className="mintBtn"> MINT </button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="mobile">
        <h1 className="mobileText">
          This Website is not suitable for Mobile and Tablet. Please access this
          website from Desktop or Laptop.
        </h1>
      </div>
    </div>
  );
}

export default Section7;
